import * as React from 'react';

/**
 * Landing-page header icon for Plans (FR-024), matching ApplicationsIcon/
 * WorkOrdersIcon's 32x32 self-contained-SVG convention. Not a new design: the
 * glyph path is copied verbatim from Applications/Work Orders' own "Record
 * Source" badge (`DetailsTab/components/PlansIcon`, shown whenever a Record
 * Source links back to a Plan), scaled from its native 13x13 viewBox up to
 * this 32x32 badge via an SVG transform rather than redrawn.
 *
 * FR-032 (2026-08-17 design QA): the original `scale(1.3)` rendered the glyph
 * visibly smaller than its Applications/Work Orders/Invoices siblings, whose
 * own glyphs fill closer to the full 32x32 canvas (e.g. Invoices' inner
 * `<svg x="6" y="6" width="20" height="20">`). Scaled up to the same ~20px
 * effective size (`scale(20/13)`, translate recentered accordingly) to match.
 */
const PlansRecordIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="none"
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  >
    <rect width="32" height="32" rx="16" fill="#E85D78" />
    <g transform="translate(6 6) scale(1.5385)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.71875 2.08268H9.89583C10.4687 2.08268 10.9375 2.55143 10.9375 3.12435V10.416C10.9375 10.9889 10.4687 11.4577 9.89583 11.4577H2.60417C2.53125 11.4577 2.46354 11.4525 2.39583 11.4421C2.19271 11.4004 2.01042 11.2962 1.86979 11.1556C1.77604 11.0566 1.69792 10.9473 1.64583 10.8223C1.59375 10.6973 1.5625 10.5566 1.5625 10.416V3.12435C1.5625 2.97852 1.59375 2.8431 1.64583 2.72331C1.69792 2.59831 1.77604 2.48372 1.86979 2.38997C2.01042 2.24935 2.19271 2.14518 2.39583 2.10352C2.46354 2.08789 2.53125 2.08268 2.60417 2.08268H4.78125C5 1.47852 5.57292 1.04102 6.25 1.04102C6.92708 1.04102 7.5 1.47852 7.71875 2.08268ZM3.64583 5.20768V4.16602H8.85417V5.20768H3.64583ZM8.85417 7.29102V6.24935H3.64583V7.29102H8.85417ZM7.29167 8.33268H3.64583V9.37435H7.29167V8.33268ZM6.25 1.95247C6.46354 1.95247 6.64062 2.12956 6.64062 2.3431C6.64062 2.55664 6.46354 2.73372 6.25 2.73372C6.03646 2.73372 5.85937 2.55664 5.85937 2.3431C5.85937 2.12956 6.03646 1.95247 6.25 1.95247ZM2.60417 10.416H9.89583V3.12435H2.60417V10.416Z"
        fill="white"
      />
    </g>
  </svg>
);

export default PlansRecordIcon;
